<div fxLayout="row" fxLayoutGap="30px" fxFlexFill>
    <mat-form-field fxFlex="20">
        <input matInput name="dataFilter" [matDatepicker]="dataFilterInput" placeholder="Data:"
               [(ngModel)]="dataFilter" (input)="onMascaraDataInput($event)">
        <mat-datepicker-toggle matSuffix [for]="dataFilterInput"></mat-datepicker-toggle>
        <mat-datepicker #dataFilterInput></mat-datepicker>
    </mat-form-field>
    <mat-form-field fxFlex="80">
        <input #descricao matInput maxlength="200" name="descricao" placeholder="Descrição:"
               [(ngModel)]="descricaoFilter">
    </mat-form-field>
</div>

<table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="filteredRequests" style="margin-top: 20px">

    <ng-container matColumnDef="dataInicio">
        <th mat-header-cell *matHeaderCellDef> Data de Início</th>
        <td mat-cell *matCellDef="let element"> {{ element.dataInicio | dataSimples }}</td>
    </ng-container>

    <ng-container matColumnDef="localExecucao">
        <th mat-header-cell *matHeaderCellDef> Local de Execução</th>
        <td mat-cell
            *matCellDef="let element"> {{ element.localExecucao != null ? element.localExecucao === 'I' ? 'Interno' : 'Externo' : '' }}
        </td>
    </ng-container>

    <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef> Descrição</th>
        <td mat-cell *matCellDef="let element"> {{ element.descricao }}</td>
    </ng-container>

    <ng-container matColumnDef="statusAnalise">
        <th mat-header-cell *matHeaderCellDef> Decisão</th>
        <td mat-cell *matCellDef="let element">
            <mat-checkbox 
                [checked]="element.statusAnalise === 'A'" 
                [indeterminate]="element.statusAnalise !== 'A' && element.statusAnalise !== 'R'"
                [disabled]="true">
                {{ getStatusLabel(element.statusAnalise) }}
            </mat-checkbox>
        </td>
    </ng-container>

    <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef> Ações</th>
        <td mat-cell *matCellDef="let element">
            <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                <mat-icon matTooltip="excluir">delete</mat-icon>
            </button>
            <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                <mat-icon>search</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<div [hidden]="!mostrarTabela">
    <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
</div>

<ng-template #tabelaSemDados>
    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
        {{ msg }}
    </div>
</ng-template>

<div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 30px">
    <div>
        <button matTooltip="Adicionar" mat-fab color="primary" (click)="novo()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>
